import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wave-emoji.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-12067d42"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-test": "home-page-header",
  class: "center-flex"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "wave-emoji",
  alt: "wave emoji",
  "data-test": "wave-emoji"
}, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'home-page-header',
  props: {
    firstName: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, [
    _createTextVNode(" Hello, " + _toDisplayString(props.firstName) + " ", 1),
    _hoisted_2
  ]))
}
}

})